import styled from 'styled-components';

export const StyledGooglePlay = styled.div`
  img {
    width: 100%;
    height: 2.8rem;
    margin-right: -0.5rem;
  }
`;
